"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriftSelect = void 0;
const react_1 = __importDefault(require("react"));
const Select_1 = require("./Select");
const FormControl_1 = require("../formControl/FormControl");
const InputLabel_1 = require("../inputLabel/InputLabel");
const FormHelperText_1 = require("../formHelperText/FormHelperText");
const MenuItem_1 = require("../menuItem/MenuItem");
const DriftSelect = (_a) => {
    var { size, value, defaultValue, label, options, helperText } = _a, rest = __rest(_a, ["size", "value", "defaultValue", "label", "options", "helperText"]);
    return (react_1.default.createElement(FormControl_1.FormControl, { size: size, fullWidth: true },
        react_1.default.createElement(InputLabel_1.InputLabel, { disabled: rest.disabled, error: rest.error, id: `select-${rest.id}` }, label),
        react_1.default.createElement(Select_1.Select, Object.assign({ defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : '', value: value, label: label }, rest), options.map((option) => {
            var _a, _b;
            return (react_1.default.createElement(MenuItem_1.MenuItem, { key: (_a = option.value) !== null && _a !== void 0 ? _a : option.label, value: (_b = option.value) !== null && _b !== void 0 ? _b : option.label }, option.label));
        })),
        !!helperText && react_1.default.createElement(FormHelperText_1.FormHelperText, { error: rest.error }, helperText)));
};
exports.DriftSelect = DriftSelect;
//# sourceMappingURL=DriftSelect.js.map